export default __webpack_public_path__ + "static/media/2 MP (1).d08a9596.png";